import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEnvelope,
    faMapMarker,
    faLink,
    faUserTie,
    faBookReader,
    faCodeBranch,
} from '@fortawesome/free-solid-svg-icons';
import {
    faLinkedinIn,
    faGithub,
} from '@fortawesome/free-brands-svg-icons';

const CVWebPage = () => {
    return (
        <div className="max-w-4xl mx-auto bg-white p-6 font-serif text-sm leading-relaxed">
            {/* Header */}
            <div className="text-center mb-6">
                <h1 className="text-4xl font-bold mb-1">Kritik Agarwal</h1>
                <h2 className="text-lg font-medium mb-2">M.Tech Computer Science & Engineering - TA</h2>
                <div className="flex justify-center items-center flex-wrap gap-x-6 gap-y-2 text-sm">
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faEnvelope} className="w-3.5 h-3.5" />
                        <a href="mailto:kritikagarwal@ymail.com" className="text-black hover:underline">kritikagarwal@ymail.com</a>
                    </div>
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faLinkedinIn} className="w-3.5 h-3.5" />
                        <a href="https://linkedin.com/in/AgarwalKritik" className="text-black hover:underline">/AgarwalKritik</a>
                    </div>
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faGithub} className="w-3.5 h-3.5" />
                        <a href="https://github.com/AgarwalKritik" className="text-black hover:underline">/AgarwalKritik</a>
                    </div>
                    {/* Added Location */}
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faMapMarker} className="w-3.5 h-3.5" />
                        <span className="text-black">Tinsukia, Assam, India</span>
                    </div>
                </div>
            </div>

            {/* Professional Summary */}
            {/* Adjusted mb to prevent too much empty space */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Professional Summary</h3>
                <p className="text-justify leading-relaxed">
                    Highly motivated M.Tech graduate in Computer Science & Engineering from IIT Hyderabad, eager to leverage expertise in Python, Cybersecurity, and data-driven innovation for impactful projects. Possesses a strong drive for continuous learning and professional growth.
                </p>
            </div>

            {/* Educational Qualifications */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Educational Qualifications</h3>
                <table className="w-full border-collapse border border-gray-400">
                    <thead>
                        <tr className="bg-gray-200">
                            <th className="border border-gray-400 p-2 text-left font-bold">Degree</th>
                            <th className="border border-gray-400 p-2 text-left font-bold">University/Institute/Board</th>
                            <th className="border border-gray-400 p-2 text-center font-bold">Year</th>
                            <th className="border border-gray-400 p-2 text-center font-bold">CGPA/Marks(%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="border border-gray-400 p-2">M.Tech Computer Science & Engineering</td>
                            <td className="border border-gray-400 p-2">Indian Institute of Technology, Hyderabad, India</td>
                            <td className="border border-gray-400 p-2 text-center">2025</td>
                            <td className="border border-gray-400 p-2 text-center">7.69</td>
                        </tr>
                        <tr>
                            <td className="border border-gray-400 p-2">B.Tech Computer Science & Engineering</td>
                            <td className="border border-gray-400 p-2">CMR University, Bengaluru, India</td>
                            <td className="border border-gray-400 p-2 text-center">2023</td>
                            <td className="border border-gray-400 p-2 text-center">8.02</td>
                        </tr>
                        <tr>
                            <td className="border border-gray-400 p-2">XII (AISSCE)</td>
                            <td className="border border-gray-400 p-2">Central Board of Secondary Education, India</td>
                            <td className="border border-gray-400 p-2 text-center">2019</td>
                            <td className="border border-gray-400 p-2 text-center">61.60%</td>
                        </tr>
                        <tr>
                            <td className="border border-gray-400 p-2">X (AISSE)</td>
                            <td className="border border-gray-400 p-2">Central Board of Secondary Education, India</td>
                            <td className="border border-gray-400 p-2 text-center">2017</td>
                            <td className="border border-gray-400 p-2 text-center">8.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Skills */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Skills</h3>
                <table className="w-full">
                    <tbody>
                        <tr>
                            <td className="font-bold py-1 pr-4 align-top">Tools & Technologies</td>
                            <td className="py-1">Jupyter Notebook, MobaXterm, SSH, Git, GitHub, VS Code, Microsoft Word, Excel, LaTeX, Overleaf, Linux</td>
                        </tr>
                        <tr>
                            <td className="font-bold py-1 pr-4 align-top">Technical Skills</td>
                            <td className="py-1">Python, SQL (Basic), HTML (Basic), C/C++ (Basic)</td>
                        </tr>
                        <tr>
                            <td className="font-bold py-1 pr-4 align-top">Soft Skills</td>
                            <td className="py-1">Self-motivated, Effective communication, Positive attitude, Adaptable, Team-oriented, Open to personal growth</td>
                        </tr>

                    </tbody>
                </table>
            </div>

            {/* Thesis/Research Work */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Thesis / Research Work</h3>
                <div className="mb-3"> {/* Adjusted spacing */}
                    <div className="flex flex-wrap justify-between items-start gap-y-1 mb-1">
                        <div className="flex-grow">
                            <span className="font-bold">Master's Thesis</span>, <em>IIT Hyderabad</em> —
                            <a href="https://raiith.krc.iith.ac.in/handle/123456789/63279" className="text-black hover:underline ml-2">
                                <FontAwesomeIcon icon={faLink} className="w-3.5 h-3.5 inline mr-1" />
                                RAIITH Repository
                            </a>
                        </div>
                        <span className="text-sm shrink-0">Jan 2024 – Jun 2025</span>
                    </div>
                    <div className="mb-1">
                        <FontAwesomeIcon icon={faUserTie} className="w-3.5 h-3.5 mr-1" />
                        <span className="font-bold">Advisor:</span> <em>Prof. Sobhan Babu Chintapalli</em>
                    </div>
                    <div className="mb-2">
                        <FontAwesomeIcon icon={faBookReader} className="w-3.5 h-3.5 inline mr-1" />
                        <span className="font-bold">Title:</span> <em>Synthetic Electronic Health Records Generation: A Transformer-Based Approach</em>
                    </div>
                    <ul className="list-disc ml-6 space-y-0.5"> {/* Adjusted space-y */}
                        <li>Employed CTGAN from the SDV library and implemented a custom Transformer-Decoder model to generate synthetic, privacy-preserving Electronic Health Records (EHRs) data.</li>
                        <li>Built a unified dataset from <a href="https://physionet.org/content/mimiciv/3.1/" className="text-blue-600 hover:underline">MIMIC-IV v3.1</a>, integrating 150+ features from 546K+ admissions and 223K+ patients.</li>
                        <li>Evaluated generation quality using SDV Score (**CTGAN: 0.85**, Transformer: 0.50) and KS-test pass rates (**89% vs. 60%**).</li>
                        <li>Assessed correlation retention (**CTGAN: 78%**, Transformer: 45%) and used privacy checks like membership inference tests (<span className="whitespace-nowrap">&lt;52% success</span>).</li> {/* Added whitespace-nowrap */}
                        <li>Found CTGAN better at structural fidelity, while the Transformer model captured rare classes with higher entropy and diversity.</li>
                    </ul>
                </div>
            </div>

            {/* Academic/Course Projects */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Academic/Course Projects</h3>

                {/* Project 1 */}
                <div className="mb-3"> {/* Adjusted spacing */}
                    <div className="flex flex-wrap justify-between items-start gap-y-1 mb-1">
                        <div className="flex-grow">
                            <span className="font-bold">Hand Cricket Game – Client-Server Model (C++)</span> —
                            <a href="https://github.com/AgarwalKritik/Public/tree/9c16d3b6eb24ff6961c71bca02ae82dc4602339f/M.Tech%20%40%20IIT-Hyderabad/CS5060-Advanced%20Computer%20Networks/Socket%20Programming/Hand%20Cricket" className="text-black hover:underline ml-2">
                                <FontAwesomeIcon icon={faCodeBranch} className="w-3.5 h-3.5 mr-1" />
                                GitHub
                            </a>
                        </div>
                        <span className="text-sm shrink-0">Aug 2023 – Nov 2023</span>
                    </div>
                    <div className="mb-1 text-sm">
                        <em>Advanced Computer Networks, IIT Hyderabad</em> — <em>Prof. Bheemarjuna Reddy Tamma</em>
                    </div>
                    <ul className="list-disc ml-6 space-y-0.5">
                        <li>Developed a real-time multiplayer hand-cricket game using TCP socket programming in C++.</li>
                        <li>Designed a client-server architecture where clients play interactively and the server maintains score state, wickets, and session control.</li>
                        <li>Implemented error handling, multi-client synchronization, and reliable bidirectional communication using TCP/IP.</li>
                    </ul>
                </div>

                {/* Project 2 */}
                <div className="mb-3"> {/* Adjusted spacing */}
                    <div className="flex flex-wrap justify-between items-start gap-y-1 mb-1">
                        <div className="flex-grow">
                            <span className="font-bold">Code Crusade – Capture the Flag (CTF) Challenge</span> —
                            <a href="https://github.com/AgarwalKritik/Public/tree/9c16d3b6eb24ff6961c71bca02ae82dc4602339f/M.Tech%20%40%20IIT-Hyderabad/CS6903-Network%20Security/CTF%20Assignment" className="text-black hover:underline ml-2">
                                <FontAwesomeIcon icon={faCodeBranch} className="w-3.5 h-3.5 mr-1" />
                                GitHub
                            </a>
                        </div>
                        <span className="text-sm shrink-0">Apr 2024</span>
                    </div>
                    <div className="mb-1 text-sm">
                        <em>Network Security, IIT Hyderabad</em> — <em>Prof. Bheemarjuna Reddy Tamma</em>
                    </div>
                    <ul className="list-disc ml-6 space-y-0.5">
                        <li>Participated in a competitive team-based CTF simulating real-world network attacks and system vulnerabilities.</li>
                        <li>Automated flag retrieval from misconfigured services using custom Python scripts integrated with Nmap, DIRB, and Metasploit.</li>
                        <li>Performed manual exploitation techniques including cryptographic cracking, buffer overflow, SQL injection, and Heartbleed attacks.</li>
                    </ul>
                </div>

                {/* Project 3 */}
                <div className="mb-3"> {/* Adjusted spacing */}
                    <div className="flex flex-wrap justify-between items-start gap-y-1 mb-1">
                        <div className="flex-grow">
                            <span className="font-bold">Synthetic Data Generation Using VAE</span> —
                            <a href="https://github.com/AgarwalKritik/Public/blob/9c16d3b6eb24ff6961c71bca02ae82dc4602339f/M.Tech%20%40%20IIT-Hyderabad/CS6890-Fraud%20Analytics%20Using%20Predictive%20and%20Social%20Network%20Techniques/Synthetic_Data_Generation_Using_VAE.ipynb" className="text-black hover:underline ml-2">
                                <FontAwesomeIcon icon={faCodeBranch} className="w-3.5 h-3.5 mr-1" />
                                GitHub
                            </a>
                        </div>
                        <span className="text-sm shrink-0">Jan 2024 – Apr 2024</span>
                    </div>
                    <div className="mb-1 text-sm">
                        <em>Fraud Analytics, IIT Hyderabad</em> — <em>Prof. Sobhan Babu Chintapalli</em>
                    </div>
                    <ul className="list-disc ml-6 space-y-0.5">
                        <li>Designed a Variational Autoencoder (VAE) to synthesize **2 million credit card transactions** with high statistical realism.</li>
                        <li>Optimized model architecture with tuned latent space, normalized inputs, and reconstruction loss minimization.</li>
                        <li>Evaluated output using KL divergence and achieved **MSE of 0.0845**; classifier accuracy: **94.93% (train)**, **92.49% (test)**.</li>
                    </ul>
                </div>
            </div>

            {/* Scholastic Achievements */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Scholastic Achievements / Awards</h3>
                <ul className="list-disc ml-6 space-y-0.5">
                    <li>
                        <div className="flex flex-wrap justify-between items-start gap-y-1">
                            <span className="flex-grow">Secured <span className="font-bold">2nd Place</span>, NPCI AI Hackathon on Synthetic AEPS Data — <em>NPCI, Hyderabad</em></span>
                            <span className="text-sm shrink-0">Jul 2024</span>
                        </div>
                    </li>
                    <li>
                        <div className="flex flex-wrap justify-between items-start gap-y-1">
                            <span className="flex-grow">Secured <span className="font-bold">2nd Place</span>, Capture the Flag (CTF) Challenge — <em>Network Security, IIT Hyderabad</em></span>
                            <span className="text-sm shrink-0">Apr 2024</span>
                        </div>
                    </li>
                </ul>
            </div>

            {/* Position of Responsibilities & Extracurricular */}
            <div className="mb-4">
                <h3 className="bg-gray-200 p-2 text-center font-bold text-lg mb-2">Position of Responsibilities & Extracurricular</h3>

                {/* Lead Organizer */}
                <div className="mb-3"> {/* Adjusted spacing */}
                    <div className="flex flex-wrap justify-between items-start gap-y-1 mb-1">
                        <span className="flex-grow"><span className="font-bold">Lead Organizer</span> | <em>prAkshepan 2.0</em>, Dept. of Computer Science & Engineering, IIT Hyderabad</span>
                        <span className="text-sm shrink-0">Jul 2024 – Aug 2024</span>
                    </div>
                    <ul className="list-disc ml-6 space-y-0.5">
                        <li>Led the ideation and execution of <a href="https://www.linkedin.com/posts/agarwalkritik_prakshepan-departmentofcse-cse-activity-7225824357875335169-4Ue1" className="font-bold text-black hover:underline">"prAkshepan 2.0"</a>, a flagship orientation initiative for M.Tech CSE freshers featuring interactive sessions, motivational talks by Ph.D. scholars and an Indian Army Major, and department-focused quizzes.</li>
                        <li>Facilitated sessions on TA/RA roles, academic workflows, and campus culture to ease the onboarding experience.</li>
                        <li>Sustained and expanded the legacy of <span className="font-bold">prAkshepan 1.0</span>, promoting a strong departmental welcome culture.</li>
                    </ul>
                </div>

                {/* Teaching Assistant */}
                <div className="mb-3"> {/* Adjusted spacing */}
                    <div className="flex flex-wrap justify-between items-start gap-y-1 mb-1">
                        <span className="flex-grow"><span className="font-bold">Teaching Assistant</span> | <em>Dept. of Computer Science & Engineering, IIT Hyderabad</em></span>
                        <span className="text-sm shrink-0">Aug 2023 – May 2025</span>
                    </div>
                    <ul className="list-disc ml-6 space-y-0.5">
                        <li>Assisted in instruction, assignment design, and evaluation for 8 UG/PG courses, including: <em>Introduction to Programming (ID1063), DBMS-I (CS3550), DBMS-II (CS3563), Software Development Fundamentals (CS1023), Advanced Data Structures and Algorithms (CS6013), Linear Optimization (CS5040), Network Security (CS6903), and Fraud Analytics (CS6890)</em>.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default CVWebPage;